import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import harvestIcon from '../../images/harvest-logo.png';

const HarvestIconWrapper = Styled.div`
    position: relative;
    right: 6px;
    z-index: 9;
    width: 18px;
    min-width: 18px;
    height: 18px;
    background-size: 18px;
    border-radius: 3px;
    background-image: url(${harvestIcon});
`;

export const HarvestIcon = ({title}) => {
	return <HarvestIconWrapper title={title} />;
};

HarvestIcon.propTypes = {
	title: PropTypes.string,
};
